import React from 'react';
import { Accordion, Icon } from 'semantic-ui-react'
import ShowLocalDate from '../LocalDateView'
import ShowLocalNumber from '../ShowLocalNumber'
import ShowOptionalField from '../ShowOptionalField'
import LoadingFrame from '../LoadingFrame'
import {Link} from 'react-router-dom'
import {client} from "../../Client";

const CommessaSelectDetail = ({ loading, commessa, onChange, fluid = false, compact = false }) => {


    let accOggettoTitle = <div></div>;
    let accOggettoContent = <div></div>;
    if (commessa.oggetto){
        accOggettoTitle = (
            <Accordion.Title>
                <Icon name='dropdown' />
                Oggetto
            </Accordion.Title>
            )
        accOggettoContent = (
            <Accordion.Content>
                <p>{commessa.oggetto}</p>
            </Accordion.Content>
        )
    }
    let cardClassName = fluid ? "ui fluid card" : "ui card";

    let clienteSeg = null;
    let otherSeg = null;

    if (compact){
        otherSeg =  <div className="content">
            <Accordion>
                <Accordion.Title>
                    <Icon name='dropdown' />
                    Dettagli...
                </Accordion.Title>
                <Accordion.Content>
                    <div className="content">
                        <div className="header">
                            {commessa.ragioneSociale}
                        </div>
                        <div className="description">
                            <p>{commessa.indirizzo} {commessa.cap} {commessa.citta} {commessa.provincia}</p>
                            <p><ShowOptionalField label="P.IVA" value={commessa.piva}/> <ShowOptionalField label="C.Fisc."
                                                                                                           value={commessa.cfisc}/>
                            </p>

                        </div>
                        <div className="ui vertical basic segment">
                            {commessa.oggetto}
                        </div>
                        <div className="ui vertical basic segment">
                            <label className="ui tiny green tag label right floated">Incarico</label><ShowLocalDate
                            data={commessa.dataIncarico} showIcon={false}/>
                        </div>
                        <div className="ui vertical basic segment">
                            <label className="ui tiny olive tag label right floated">Inizio Prest</label><ShowLocalDate
                            data={commessa.dataInizioPrestazione} showIcon={false}/>
                        </div>
                        <div className="ui vertical basic segment">
                            <label className="ui tiny orange tag label right floated">Fine Prest</label><ShowLocalDate
                            data={commessa.dataFinePrestazione} showIcon={false}/>
                        </div>
                        <div className="ui vertical basic segment">
                            <label className="ui tiny red tag label right floated">Chiusura</label><ShowLocalDate
                            data={commessa.dataChiusura} showIcon={false}/>
                        </div>
                        <div className="ui vertical basic segment">
                            <label>Priorità</label>
                            <label className="ui label right floated">{commessa.priorita}</label>
                        </div>
                        <div className="ui vertical basic segment">
                            <label>Incasso presunto</label>
                            <label className="ui label right floated">
                                <ShowLocalNumber value={commessa.incassoPresunto}/></label>
                        </div>
                        <div className="ui vertical basic segment">
                            <label>Peso</label>
                            <label className="ui label right floated">{commessa.peso}</label>
                        </div>
                    </div>
                </Accordion.Content>

            </Accordion>
        </div>
    }
    else {
        clienteSeg = <div className="content">
            <div className="header">
                {commessa.ragioneSociale}
            </div>
            <div className="description">
                <p>{commessa.indirizzo} {commessa.cap} {commessa.citta} {commessa.provincia}</p>
                <p><ShowOptionalField label="P.IVA" value={commessa.piva}/> <ShowOptionalField label="C.Fisc."
                                                                                               value={commessa.cfisc}/>
                </p>

            </div>
        </div>

        otherSeg =  <div className="content">
            <Accordion>
                {accOggettoTitle}
                {accOggettoContent}
                <Accordion.Title>
                    <Icon name='dropdown' />
                    Dettagli...
                </Accordion.Title>
                <Accordion.Content>
                    <div className="ui vertical basic segment">
                        <label className="ui tiny green tag label right floated">Incarico</label><ShowLocalDate
                        data={commessa.dataIncarico} showIcon={false}/>
                    </div>
                    <div className="ui vertical basic segment">
                        <label className="ui tiny olive tag label right floated">Inizio Prest</label><ShowLocalDate
                        data={commessa.dataInizioPrestazione} showIcon={false}/>
                    </div>
                    <div className="ui vertical basic segment">
                        <label className="ui tiny orange tag label right floated">Fine Prest</label><ShowLocalDate
                        data={commessa.dataFinePrestazione} showIcon={false}/>
                    </div>
                    <div className="ui vertical basic segment">
                        <label className="ui tiny red tag label right floated">Chiusura</label><ShowLocalDate
                        data={commessa.dataChiusura} showIcon={false}/>
                    </div>
                    <div className="ui vertical basic segment">
                        <label>Priorità</label>
                        <label className="ui label right floated">{commessa.priorita}</label>
                    </div>
                    <div className="ui vertical basic segment">
                        <label>Incasso presunto</label>
                        <label className="ui label right floated">
                            <ShowLocalNumber value={commessa.incassoPresunto}/></label>
                    </div>
                    <div className="ui vertical basic segment">
                        <label>Peso</label>
                        <label className="ui label right floated">{commessa.peso}</label>
                    </div>
                </Accordion.Content>
            </Accordion>
        </div>
    }

    let linkCommessa = null;
    if (client.getCurrentUser().isrolecommesse) {
        linkCommessa = (<Link className="right floated" to={"/app/commesse/view/" + commessa.idCommessa} title="Vai al dettaglio della Commessa"><i className="ui share icon" /></Link>)
    }

    return <div className={cardClassName}>
            <div className="content">
                <div className="header">
                    <a className="ui empty circular label" style={{backgroundColor: commessa.colore}}></a>
                    &nbsp;{commessa.codice}
                    &nbsp;{commessa.nome}&nbsp;
                    {
                        commessa.conclusa ?
                            <label className="ui tiny red  label center floated">Prestazione conclusa</label>
                            :
                            <label className="ui tiny green  label center floated">Non conclusa</label>
                    }&nbsp;
                    {
                        commessa.archiviata ?
                            <label className="ui tiny red  label center floated">Archiviata</label>
                            :
                            <label className="ui tiny green  label center floated">Non archiviata</label>
                    }
                    {linkCommessa}
                </div>
            </div>
           {clienteSeg}
        {otherSeg}

            {
                onChange !== undefined ? (
                        <div className="extra content">
                            <div className="ui grid">
                                <div className="center aligned sixteen wide column">
                                    <a className="ui" onClick={(ev) => {ev.preventDefault();onChange(undefined)}}><i
                                        className="undo icon"/>Cambia commessa</a>
                                </div>
                            </div>
                        </div>
                    ):<div></div>
            }
            <LoadingFrame visible={loading}/>
        </div>
};

export default CommessaSelectDetail;


/** WEBPACK FOOTER **
 ** ./src/components/commesse/CommessaSelectDetail.js
 **/